import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpErrorResponse } from '@angular/common/http';
import { VendorService } from '../../../../services/vendor.service';
import { LoaderComponent } from '../../../loader/loader.component';
import { vendor } from '../../../../model/masters.model';
import { CustomerService } from '../../../../services/customer.service';
import { ContactListComponent } from "../../contact/contact-list/contact-list.component";
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import { GlAccountLookupComponent } from '../../../Lookup/glAccount-lookup/glAccount-lookup.component';
import { SalesService } from '../../../../services/sales.service';
import { VendorBankLookupComponent } from '../../../Lookup/vendor-bank-lookup/vendor-bank-lookup.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-new-vendor',
  standalone: true,
  providers: [MessageService],
  templateUrl: './new-vendor.component.html',
  styleUrl: './new-vendor.component.scss',
  imports: [SharedModule, CommonModule, LoaderComponent, ContactListComponent]
})
export class NewVendorComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('dt1') dt1!: Table;
  submitted: boolean = false;
  loader: boolean = false;
  // previewImage: SafeUrl | undefined;
  saveImage: Blob | undefined;
  vendorId: number | undefined;
  isEditMode: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  isManual: boolean = false;
  Addressid: number | undefined;
  selectedFile: File | null = null;
  previewImage: string | null = null;
  RecentInteractionsData: any[] = [];
  selectedMonth: number | null = null;
  selectedYear: number | null = null;
  vendorCode: any;
  currentYear = new Date().getFullYear();



  constructor(private router: Router, private route: ActivatedRoute, public ref: DynamicDialogRef,
    private messageService: MessageService, private sanitizer: DomSanitizer, public dialogService: DialogService,
    private Vendorservice: VendorService, private customerService: CustomerService, private salesService: SalesService) { }

  ngOnInit(): void {
    this.getEditRecord()
    this.getStateList();
    document.title = 'Create Vendor';
    this.vendorDetailsForm.controls.createdBy.setValue(localStorage.getItem('username'));
    // this.route.queryParams.subscribe(params => {
    //   this.vendorId = params['vendorId'];
    //   this.isEditMode = !!this.vendorId;
    this.manualEntry();
    this.patchVendorDetails();
    // if (this.isEditMode) {
    // If in edit mode, fetch the vendor details
    //     this.Vendorservice.getVendorById(this.vendorId).subscribe(
    //       (vendor: any) => {
    //         if (vendor) {
    //           this.Addressid = vendor.addressId
    //           this.vendorDetailsForm.patchValue(vendor);
    //         } else {
    //           console.error('vendor data not found.');
    //         }
    //       },
    //       (error: any) => {
    //         console.error('Error fetching vendor data:', error);
    //       }
    //     );
    //   } else {
    //     this.resetForm();
    //   }
    // });
  }

  resetForm() {
    this.vendorDetailsForm.reset();
    this.vendorDetailsForm.controls.isInventoryVendor.setValue(true);
    this.vendorDetailsForm.controls.manualEntry.setValue(true);
    this.vendorDetailsForm.controls.address.controls.country.setValue('India');
  }

  vendorDetailsForm = new FormGroup({
    vendorName: new FormControl('', Validators.required),
    //vendorCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    vendorCode: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    vendorImage: new FormControl(),
    vendorDescription: new FormControl(''),
    glAccountCode: new FormControl(),
    outstandingRec: new FormControl(),
    vendorCredit: new FormControl(),
    isActive: new FormControl(true),
    isInventoryVendor: new FormControl(true),
    isInternalVendor: new FormControl(false),
    termsCode: new FormControl(),
    paymentTermsId: new FormControl(),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      stateCode: new FormControl(''),
      zip: new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]),
      country: new FormControl('India', Validators.required),
      CreatedBy: new FormControl(''),
      UpdatedBy: new FormControl(''),
    }),
    phone: new FormControl('', Validators.pattern(/^\d{10}$/)),

    mobile: new FormControl('', [Validators.pattern(/^\d{10}$/)]),
    email: new FormControl('', Validators.email),
    website: new FormControl(''),
    tags: new FormControl(''),
    gstin: new FormControl(''),
    createdBy: new FormControl(''),
    upatedBy: new FormControl('')
  });

  items: MenuItem[] = [
    {
      label: 'Bank Account',
      command: () => this.showVendorBank(),
    },
  ];

  showVendorBank() {
    this.ref = this.dialogService.open(VendorBankLookupComponent, {
      header: `Vendor Bank for ${this.vendorDetailsForm.controls.vendorCode.value}`,
      width: '80%',
      data: { VendorCode: this.vendorDetailsForm.controls.vendorCode.value, VendorId: this.vendorId }
    });
  }


  vendor: vendor[] = [];
  getEditRecord() {
    this.route.queryParams.subscribe(params => {
      this.vendorId = params['vendorId'];
      this.isEditMode = !!this.vendorId;
      if (this.isEditMode) {
        document.title = 'Update Vendor';
        // If in edit mode, fetch the vendor details
        this.Vendorservice.getVendorById(this.vendorId).subscribe(
          (vendor: any) => {
            if (vendor) {
              // console.log(vendor)
              if (vendor.vendorImage) {
                this.setBase64Image(vendor.vendorImage);
              }
              this.vendorDetailsForm.patchValue(vendor);
            } else {
              console.error('vendor data not found.');
            }
          },
          (error: any) => {
            console.error('Error fetching vendor data:', error);
          }
        );
      }
    });
  }

  setBase64Image(imageBase64: string) {
    this.previewImage = `data:image/jpeg;base64,${imageBase64}`;
  }

  get formControls() {
    return this.vendorDetailsForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.vendorDetailsForm.invalid) {
      isValid = false;
      // console.error('Form errors:', this.getFormValidationErrors());

    }

    return isValid;
  }

  saveVendor(data: any, isEditMode: boolean) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      // console.error('Form errors:', this.getFormValidationErrors());
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' });
      return;
    }
    if (isEditMode) {
      this.updateVendor(data);
    } else {
      this.createVendor(data);
    }
  }

  getFormValidationErrors() {
    const errors: string[] = [];
    Object.keys(this.vendorDetailsForm.controls).forEach(key => {
      const controlErrors = this.vendorDetailsForm.get(key)?.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          errors.push(`${key} - ${keyError}: ${controlErrors[keyError]}`);
        });
      }
    });
    return errors;
  }

  createVendor(data: any) {
    // data.vendorCode = parseInt(data.vendorCode);
    // data.vendorCode = data.vendorCode.toString();
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' });
      return;
    }
    this.loader = true;
    const username = localStorage.getItem('username');
    data.createdBy = username;
    this.Vendorservice.createVendor(data).subscribe({
      next: (data: any) => {
        if (data.success == true) {
          this.loader = false;
          this.uploadImage(data.vendorId)
          this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
          setTimeout(() => {
            this.router.navigate(['/home/listvendors']);
          }, 1000);
        } else {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        }
      },
      error: (error: any) => {
        console.error('Error creating vendor:', error);
        this.loader = false;
      }
    });
  }

  uploadImage(productId: number) {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);
      this.Vendorservice.uploadVendorImage(productId, formData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image uploaded successfully.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Image upload failed.' });
          }
        },
      });
    }
  }

  updateVendor(data: any) {
    data.vendorId = this.vendorId;
    // data.vendorCode = parseInt(data.vendorCode);
    // data.vendorCode = data.vendorCode.toString();
    const username = localStorage.getItem('username');
    data.updatedBy = username;
    if (data) {
      this.Vendorservice.updateVendor(data).subscribe({
        next: Data => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'vendor Updated Successfully.' });
          if (this.selectedFile) {
            this.uploadImage(data.vendorId);
          }
          setTimeout(() => {
            this.router.navigate(['/home/listvendors']);
          }, 1000)
          //this.salesPersonForm.reset();
        },
        error: error => {
          console.error('Error updating vendor', error);
        }
      });
    } else {
      this.createVendor(data);
    }
  }
  cancel() {
    this.router.navigate(['/home/listvendors']);
  }

  // onFileSelected(event: any) {
  //   if(event){
  //     const file = event.target.files[0];
  //     this.saveImage = file;
  //     // console.log(this.saveImage);
  //     this.previewImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  //   }
  // }

  // deleteImage(){
  //   this.previewImage = undefined;
  // }
  onFileSelected(event: any): void {
    const file = event.target.files[0];
    const fileSizeKB: number = Math.round(file.size / 1024); // Convert bytes to KB
    if (fileSizeKB > 5000) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select an image file up to 5MB in size.' })
      return;
    }
    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a image.' })
      return;
    }
    if (file) {
      this.selectedFile = file;
      this.createImagePreview(file);
    }
  }

  createImagePreview(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.previewImage = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  show() {
    console.log(this.selectedFile);
  }

  deleteImage(): void {
    if (this.selectedFile || this.previewImage) {

      console.log('Deleting file:', this.selectedFile?.name || 'existing image');
      this.selectedFile = null;
      this.previewImage = null; // Clear the image preview
      this.vendorDetailsForm.controls.vendorImage.setValue(null);
      this.fileInput.nativeElement.value = '';
    }
  }


  patchVendorDetails(): void {
    this.route.queryParams.subscribe(params => {
      this.vendorId = params['vendorId'];
      this.isEditMode = !!this.vendorId;
      if (this.isEditMode) {
        this.loadOutstandingAmount(this.vendorId);
        this.Vendorservice.getVendorById(this.vendorId).subscribe({
          next: (data: any) => {
            //console.log(data);
            if (data) {
              this.vendorDetailsForm.patchValue({
                vendorName: data.vendorName,
                vendorCode: data.vendorCode,
                vendorImage: data.vendorImage,
                vendorDescription: data.vendorDescription,
                phone: data.phone,
                mobile: data.mobile,
                email: data.email,
                gstin: data.gstin,
                tags: data.tags,
                website: data.website,
                termsCode: data.termsCode,
                glAccountCode: data.glAccountCode,
                isActive: data.isActive,
                upatedBy: data.updatedBy,
                address: {
                  addressLine1: data.address.addressLine1,
                  addressLine2: data.address.addressLine2,
                  city: data.address.city,
                  state: data.address.state,
                  stateCode: data.address.stateCode,
                  zip: data.address.zip,
                  country: data.address.country
                }
              });
              this.getrecentInteractionsById(data.vendorCode);
              this.vendorCode = data.vendorCode;
              if (data.customerImage) {
                this.setBase64Image(data.customerImage);
              }
            }
          },
          error: (error: any) => {
            console.error('Error fetching Company Information data:', error);
          }
        });

      }
    });
  }

  manualEntry() {
    const manualEntryValue = this.vendorDetailsForm.controls.manualEntry.value;
    if (manualEntryValue === true) {
      this.vendorDetailsForm.controls.vendorCode.setValue('');
      this.isManual = false;
    } else {
      if (!this.isEditMode) {
        this.isManual = true
        this.getVendorCode();
      }
    }
  }

  getVendorCode() {
    this.loader = true;
    this.Vendorservice.autogenerateVendorCode().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'V';
        // const vendorCode = alphanumericCode + data;
        this.vendorDetailsForm.controls.vendorCode.setValue(data.fullNumber);
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }

  checkVendorCode() {
    if (!this.vendorDetailsForm.controls.vendorCode.value) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter' });
      return;
    }
    if (!this.isEditMode) {
      this.Vendorservice.checkVendorCode(this.vendorDetailsForm.controls.vendorCode.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.vendorDetailsForm.controls.vendorCode.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.vendorDetailsForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  // getStateList() {
  //   this.loader = true;
  //   this.customerService.getStateList().subscribe({
  //     next: (data: any) => {
  //       this.stateList = data;
  //       //console.log(this.stateList);

  //       this.loader = false;
  //     },
  //     error: error => {
  //       console.log(error);
  //       this.loader = false;
  //     }
  //   });
  // }

    getStateList() {
  this.customerService.getStateList().subscribe({
    next: (data: any) => {
      this.stateList = (data ?? []).sort((a: any, b: any) =>
        (a.stateName ?? a.name ?? a.label ?? '').localeCompare(
          b.stateName ?? b.name ?? b.label ?? ''
        )
      );
    },
    error: error => {
      console.log(error);
    }
  });
}

  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }

  // setState(event: any) {
  //   this.vendorDetailsForm.controls.address.controls.state.setValue(event.value.stateName);
  //   this.vendorDetailsForm.controls.address.controls.stateCode.setValue(event.value.stateCode);
  //   this.vendorDetailsForm.controls.address.controls.UpdatedBy.setValue(localStorage.getItem('username'));
  //   this.vendorDetailsForm.controls.gstin.setValue(event.value.stateCode);
  // }

  // setState(event: any) {
  //   const addressForm = this.vendorDetailsForm.get('address') as FormGroup;

  //   addressForm.patchValue({
  //     state: event.value.stateName,
  //     stateCode: event.value.stateCode,
  //     UpdatedBy: localStorage.getItem('username')
  //   });

  //   this.vendorDetailsForm.get('gstin')?.setValue(event.value.stateCode);
  // }


  setState(event: any) {
    this.vendorDetailsForm.patchValue({
      gstin: event.value.stateCode,
      address: {
        state: event.value.stateName,
        stateCode: event.value.stateCode,
        CreatedBy: localStorage.getItem('username'),
      }
    });
    if (this.isEditMode) {
      this.vendorDetailsForm.patchValue({
        gstin: event.value.stateCode,
        address: {
          state: event.value.stateName,
          stateCode: event.value.stateCode,
          UpdatedBy: localStorage.getItem('username'),
        }
      });
    }
  }

  checkState() {
    const enteredState = this.vendorDetailsForm.controls.address.controls.state.value;
    const validStates = this.stateList.map(state => state.stateName);

    if (validStates.includes(enteredState)) {
    } else {
      this.vendorDetailsForm.controls.address.controls.state.setValue('');
    }
  }

  getTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.vendorDetailsForm.patchValue({
          termsCode: data.paymentTermsDescription,
          paymentTermsId: data.paymentTermsId
        })
      }
    })
  }

  getGLAccount() {
    this.ref = this.dialogService.open(GlAccountLookupComponent, {
      header: 'GL Account',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.vendorDetailsForm.patchValue({
          glAccountCode: `${data.accountCode} - ${data.accountName}`
        })
      }
    })
  }

  onKeydown(event: KeyboardEvent) {
    console.log('Keydown event:', event);

    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  getrecentInteractionsById(vendorCode: any) {
    this.salesService.getrecentInteractionsByVendorNumber(vendorCode).subscribe(
      (data: any) => {
        this.RecentInteractionsData = data;
      }
    )
  }

  filterByMonthYear() {
    if (this.selectedMonth === null || this.selectedYear === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select both month and year to filter data.'
      });
      return;
    }

    this.loader = true;
    this.salesService.getFilteredData(this.selectedMonth, this.selectedYear, this.vendorCode).subscribe({
      next: (data) => {
        this.RecentInteractionsData = data;
        this.loader = false;

        if (this.dt1) {
          this.dt1.first = 0;
          this.dt1.firstChange.emit(0);
        }

        if (data.length === 0) {
          this.messageService.add({
            severity: 'info',
            summary: 'No Data',
            detail: 'No interactions found for the selected month and year.'
          });
        }
      },
      error: (error) => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch filtered data. Please try again.'
        });
        console.error('Error fetching filtered data:', error);
      }
    });
  }


  months = [
    { name: 'Select Month', value: null },
    ...Array.from({ length: 12 }, (_, index) => ({
      name: new Date(0, index).toLocaleString('default', { month: 'long' }),
      value: index + 1
    }))
  ];

  years = [
    { name: 'Select Year', value: null },
    ...Array.from({ length: 5 }, (_, i) => {
      const year = this.currentYear - 2 + i;
      return {
        name: String(year),
        value: year
      };
    })
  ];

  onMonthChange(event: any) {
    this.selectedMonth = event.value;
  }

  onYearChange(event: any) {
    this.selectedYear = event.value;
  }

  refresh(): void {
    this.getrecentInteractionsById(this.vendorCode);
    this.selectedMonth = null;
    this.selectedYear = null;

    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.firstChange.emit(0);
    }
  }

  loadOutstandingAmount(id: number | undefined): void {
    if (!id) return;

    this.Vendorservice.getOutstandingAmount(id.toString())
      .subscribe({
        next: (amount: number) => {
          this.vendorDetailsForm.patchValue({
            outstandingRec: amount
          });
        },
        error: (err: any) => {
          console.error('Outstanding amount error', err);
        }
      });
  }
}
